export class HelpText {
  constructor(
    readonly text: string,
    readonly link?: { caption: string; href: string }
  ) {}

  toString(): string {
    return this.text || this.link?.caption || this.link?.href || '';
  }
}

export declare type HelpTextDictionary = {
  [key: string]: HelpText;
};
